// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3dtwj","savePackageButton":"ClientWallet_savePackageButton__23PQH"};